import { type MaskAdapter } from '.';

const cepMask: MaskAdapter = {
  apply: value => {
    if (!value) return '';
    const cleaned = value.toString().replace(/[^\d]/gi, '');
    return cleaned.substring(0, 5) + (cleaned.length > 5 ? '-' + cleaned.substring(5, 8) : '');
  },
  clean: value => {
    return value.toString().replace(/[^\d]/gi, '');
  }
};

export default cepMask;
